'use strict';

const _ = require('lodash');

const ListController = function ($scope, $rootScope, Flux, NavActions) {

  const vm = this;
  const AnnotationStore = Flux.Store.get('AnnotationStore');
  const MapActions = Flux.Actions.get('MapActions');
  const UserStore = Flux.Store.get('UserStore');
  const TopControlsStore = Flux.Store.get('TopControlsStore');

  vm.groupedList = [];
  vm.filteredList = [];
  vm.searchTerm = '';

  // Format annotation to display in list widget
  const formatAnnotation = (annotation) => {

    return {
      name: annotation.name,
      id: annotation.id
    };
  };

  const formatUser = (firstName, lastName, email) => {

    if (firstName || lastName) {
      return firstName + ' ' + lastName;
    }
    else {
      return email;
    }
  };

  const _loadAnnotations = () => {

    vm.useMapboxGL = TopControlsStore.get('useMapboxGL');
    const available = AnnotationStore.get('available');

    if (available) {
      vm.annotations = available.map(formatAnnotation);
      const current = AnnotationStore.get('current');
      const currentUser = UserStore.get('user');
      vm.groupedList = _.chain(available)
      .groupBy('userId')
      .sortBy((annotations) => {

        return currentUser.id === annotations[0].userId ? -1 : 1;
      })
      .map((annotations) => {

        const user = annotations[0].userName;
        let formattedUserName;
        if (annotations[0].userId === currentUser.id) {
          formattedUserName = 'My Annotations';
        }
        else {
          formattedUserName = formatUser(user.firstName, user.lastName, user.email);
        }
        return {
          category: formattedUserName,
          list: annotations
        };
      })
      .value();
      vm.annotationsSelected = _.indexBy(current, 'id');
    }
    else {
      vm.annotations = {};
      vm.annotationsSelected = {};
    }
  };

  // TODO: This is repeated in several navLeft children directives.
  // Refactor to a central place
  vm.closeDrawer = (options) => {

    options = options || {};
    if (options.prompt) {
      $rootScope.$broadcast(options.prompt);
    }
    else {
      NavActions.CloseDrawer.dispatch();
    }
  };

  vm.hasEditPermissions = (annotation) => {

    const permissions = AnnotationStore.getPermissions(annotation.id);
    return permissions.edit;
  };

  vm.deleteAnnotation = (annotation, $event) => {

    $event.stopPropagation(); // Stop propagation to prevent activation on list item
    $rootScope.$broadcast('dialog:annotation:promptDelete', {
      id: annotation.id
    });
  };

  $scope.$on('dialog:annotation:confirmDelete', (ev, data) => {

    MapActions.DestroyAnnotation.dispatch(data.id);
    AnnotationStore.once(AnnotationStore.Events.AnnotationDestroyed, () => {

      MapActions.AnnotationEditEnd.dispatch(true);
    });
  });

  vm.editAnnotation = (annotation, $event) => {

    $event.stopPropagation(); // Stop propagation to prevent activation on list item
    MapActions.EditAnnotationStart.dispatch(annotation.id);
  };

  //////////////////////////////////////////////////////////////////
  // Event Handlers
  //////////////////////////////////////////////////////////////////

  const onSelectedItem = (ev, data) => {

    const annotationId = data.item.id;
    AnnotationStore.activate(annotationId);
    ev.stopPropagation();
  };

  const onDeselectedItem = (ev, data) => {

    const annotationId = data.item.id;
    AnnotationStore.deactivate(annotationId);
    ev.stopPropagation();
  };

  $scope.$on('list:deselectedItem', onDeselectedItem);
  $scope.$on('list:selectedItem', onSelectedItem);
  AnnotationStore.on(AnnotationStore.Events.AnnotationDestroyed, _loadAnnotations);
  TopControlsStore.on(TopControlsStore.Events.ChangedMap, _loadAnnotations);
  // Initialization section

  _loadAnnotations();
};

ListController.$inject = [
  '$scope', '$rootScope', 'sbFlux', 'NavActions'
];

module.exports = ListController;



// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/annotations/list/AnnotationListController.js